module.exports = __webpack_public_path__ + "static/media/The-Shore-SPA.27f0c173.jpg";